import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    confirm: String,
    url: String
  }

  delete(event) {
    event.preventDefault()

    if (this.confirmValue && !confirm(this.confirmValue)) {
      return
    }

    // Show loading state
    this.element.classList.add("is-loading")
    this.element.disabled = true

    // Perform the delete request
    fetch(this.urlValue, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': this.getMetaValue('csrf-token'),
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (response.redirected) {
        // Follow the redirect
        window.location.href = response.url
      } else if (response.ok) {
        // If no redirect, go back to the previous page
        if (window.history.length > 1) {
          window.history.back()
        } else {
          // Fallback to home if no history
          window.location.href = '/'
        }
      } else {
        throw new Error('Delete failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      // Remove loading state on error
      this.element.classList.remove("is-loading")
      this.element.disabled = false
      alert('Failed to delete cluster. Please try again.')
    })
  }

  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`)
    return element ? element.getAttribute('content') : null
  }
}
